import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";

import HomePage from "./pages/HomePage";
import ApplicationForm from "./pages/ApplicationForm";
import TrackApplication from "./pages/TrackApplication";
import RequirementsPage from "./pages/RequirementsPage";

import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminApplicants from "./pages/admin/AdminApplicants";
import AdminApplicantDetail from "./pages/admin/AdminApplicantDetail";
import AdminHirings from "./pages/admin/AdminHirings";
import AdminAccounts from "./pages/admin/AdminAccounts";
import AdminChat from "./pages/admin/AdminChat";
import AdminFiles from "./pages/admin/AdminFiles";
import AdminChatbotFAQ from "./pages/admin/AdminChatbotFAQ";
import AdminFinancials from "./pages/admin/AdminFinancials";
import AdminAssignments from "./pages/admin/AdminAssignments";

function AdminRoute({ children, super: superOnly }) {
  const { user, role, loading } = useAuth();
  if (loading) return <div className="page text-center"><div className="spinner" style={{ borderTopColor: "#c8881b" }}></div></div>;
  if (!user) return <Navigate to="/admin/login" />;
  if (superOnly && role !== "superadmin") return <Navigate to="/admin" />;
  if (role !== "admin" && role !== "superadmin") return <Navigate to="/admin/login" />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/apply" element={<ApplicationForm />} />
          <Route path="/track" element={<TrackApplication />} />
          <Route path="/requirements" element={<RequirementsPage />} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          <Route path="/admin/applicants" element={<AdminRoute><AdminApplicants /></AdminRoute>} />
          <Route path="/admin/applicants/:id" element={<AdminRoute><AdminApplicantDetail /></AdminRoute>} />
          <Route path="/admin/hirings" element={<AdminRoute><AdminHirings /></AdminRoute>} />
          <Route path="/admin/chat" element={<AdminRoute><AdminChat /></AdminRoute>} />
          <Route path="/admin/accounts" element={<AdminRoute super><AdminAccounts /></AdminRoute>} />
          <Route path="/admin/files" element={<AdminRoute><AdminFiles /></AdminRoute>} />
          <Route path="/admin/financials" element={<AdminRoute><AdminFinancials /></AdminRoute>} />
          <Route path="/admin/assignments" element={<AdminRoute super><AdminAssignments /></AdminRoute>} />
          <Route path="/admin/chatbot-faq" element={<AdminRoute><AdminChatbotFAQ /></AdminRoute>} />

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}
